/* ============================================================
   HEMP HOUNDS — Stats / trust-bar count-up
   Extracted from the section's {% javascript %} block into an
   isolated, deferred asset so a runtime throw in ANY other
   section's concatenated JS can no longer prevent the counters
   from animating (same remedy as hh-product.js). Re-init-safe.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function runCount(el) {
    el.setAttribute('data-hh-counted', '');
    var host = el.closest('.hh-stats');
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var dur = host ? (parseInt(host.getAttribute('data-count-dur'), 10) || 1400) : 1400;
    var animate = host ? host.getAttribute('data-count-animate') !== 'false' : true;
    var fmt = function (n) { return n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); };
    if (reduce || !animate) { el.textContent = fmt(target); return; }
    var start = performance.now();
    var tick = function (now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = fmt(target);
    };
    requestAnimationFrame(tick);
  }

  function initStats(root) {
    var scope = root || document;
    var counters = scope.querySelectorAll('.hh-stats [data-count]:not([data-hh-counted])');
    if (!counters.length) return;
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(runCount);
    }
  }

  window.HH = window.HH || {};
  window.HH.initStats = initStats;

  function boot() { initStats(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initStats(e.target); });
})();
